import React, { useEffect, useState } from 'react';
import { FaArrowLeft } from 'react-icons/fa6';
import { useParams } from 'react-router-dom';

import BarraInferiorBotoes from '../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../components/BarraSubAbas';
import ContainerConteudo from '../../../../components/ContainerConteudo';
import CustomTable from '../../../../components/CustomTable';
import StyledLink from '../../../../components/Link';
import SubAbas from '../../../../components/SubAbas';
import WorkspaceBotoes from '../../../../components/WorkspaceBotoes';
import { getUser } from '../../../../modules/contexts/Auth/RequireAuth';
import { useCargoFuncao } from '../../../../services/enum/useCargoFuncao';
import { getSesVinculoBySesId } from '../../../../services/ses/sesVinculoService';
import { ENTITY } from '../../../../utils/entityNames';
import {
  ExportToExcel,
  formatDate,
  formataNomeMeioSiglas,
} from '../../../../utils/functions';
import {
  headersSesVinculo as headers,
  valoresExibidosOffCanvasSES as valoresExibidos,
  fieldObjectSes as fieldObject,
  SesBondTableRow,
} from '../SES/auxiliarSES';
import SubAbasSES from '../SES/subabasSES';

//DADOS USUARIO
const user = getUser();
const userID = user.sub;
const entity = ENTITY.ENTITY_VinculoSesUsuario;
const SESVinculo: React.FC = () => {
  //PERMISSOES-MODULOS

  //PERMISSOES
  // Dados do módulo
  const params = useParams();
  const fichaID = String(params.id);

  const subAbas = SubAbasSES(fichaID);
  const cargoOptions = useCargoFuncao();

  const [, setShowOffcanvas] = useState<boolean>(false);
  const [, setVinculoSesUsuarioId] = useState<string>('');
  const [, setUpdating] = useState<boolean>(false);
  const [data, setData] = useState<any[]>([]);

  const [formSes] = useState({
    sesId: 0,
    cnpj: '',
    razaoSocial: '',
  });

  // Buscar dados
  const fetchData = async (id: string) => {
    try {
      const sesVinculoData = await getSesVinculoBySesId(id);
      setData(sesVinculoData);
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };

  useEffect(() => {
    fetchData(fichaID);
  }, []);

  //Dados da tabela
  const tableData = data.map((item) => ({
    id: item.id,
    status: item.stVinculo,
    nome: item.sesUsuario.nome,
    dataInicio: item.dataInicio,
    cargo: item.sesUsuario ? cargoOptions[item.sesUsuario.cargo].label : '',
  }));

  //Dados do Offcanvas
  let offCanvasData = data.map((item) => ({
    id: item.id,
    dataRegistro:
      formatDate(item.dataRegistro) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
    dataUltimaAtualizacao:
      formatDate(item.dataUltimaAtualizacao) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioAtualizacao.nomeCompleto),

    dataUltimaVisualizacao:
      formatDate(item.dataUltimaVisualizacao) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioUltimaVisualizacao.nomeCompleto),
    nEdicoes: item.nEdicoes,
    nVisualizacoes: item.nVisualizacoes,
    cpf: item.sesUsuario.cpf,
    nomeCompleto: item.sesUsuario.nome,
    cargo: item.sesUsuario ? cargoOptions[item.sesUsuario.cargo].label : '',
    celular: item.sesUsuario.celular,
    observacoes: item.observacoes,
  }));

  const exportData = data.map((item) => ({
    //Dados da entidade
    id: item.id,
    nomeCompleto: item.sesUsuario.nomeCompleto,
    cpf: item.sesUsuario.cpf,
    cargo: item.cargo ? cargoOptions[item.cargo].label : '',
    observacoes: item.observacoes,

    //Dados do Ses
    sesId: formSes.sesId,
    cnpj: formSes.cnpj,
    razaoSocial: formSes.razaoSocial,

    //Logs
    dataRegistro: item.dataRegistro,
    dataUltimaAtualizacao: item.dataUltimaAtualizacao,
    dataUltimaVisualizacao: item.dataUltimaVisualizacao,
    usuarioRegistro: formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
    usuarioAtualizacao: formataNomeMeioSiglas(
      item.usuarioAtualizacao.nomeCompleto,
    ),
    usuarioUltimaVisualizacao: formataNomeMeioSiglas(
      item.usuarioUltimaVisualizacao.nomeCompleto,
    ),
    nEdicoes: item.nEdicoes,
    nVisualizacoes: item.nVisualizacoes,
  }));

  const handleShowOffcanvas = () => {
    setShowOffcanvas((show) => !show);
  };

  const handleRowClick = (row: SesBondTableRow) => {
    setVinculoSesUsuarioId(String(row.id));
    setUpdating(true);
    handleShowOffcanvas();
    offCanvasData = data
      .filter((item) => item.id == row.id)
      .map((item: any) => ({
        id: item.id,
        dataRegistro:
          formatDate(item.dataRegistro) +
          ' - ' +
          formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
        dataUltimaAtualizacao:
          formatDate(item.dataUltimaAtualizacao) +
          ' - ' +
          formataNomeMeioSiglas(item.usuarioAtualizacao.nomeCompleto),

        dataUltimaVisualizacao:
          formatDate(item.dataUltimaVisualizacao) +
          ' - ' +
          formataNomeMeioSiglas(item.usuarioUltimaVisualizacao.nomeCompleto),
        nEdicoes: item.nEdicoes,
        nVisualizacoes: item.nVisualizacoes,
        cpf: item.sesUsuario.cpf,
        nomeCompleto: item.sesUsuario.nomeCompleto,
        cargo: item.sesUsuario.cargo
          ? cargoOptions[item.sesUsuario.cargo].label
          : '',
        celular: item.sesUsuario.celular,
        observacoes: item.observacoes,
      }));
  };

  return (
    <>
      <SubAbas>
        <StyledLink
          to="/daf/ses/ses"
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
            // backgroundColor: '#E1ECFE',
            backgroundColor: '#C5D4EB',
          }}
        >
          <FaArrowLeft />
        </StyledLink>
        <BarraSubAbas subAbas={subAbas} />
      </SubAbas>

      <ContainerConteudo>
        <CustomTable
          headers={headers}
          data={tableData}
          onRowClick={handleRowClick}
        />
      </ContainerConteudo>

      <BarraInferiorBotoes>
        <WorkspaceBotoes
          download
          //   downloadDisabled={btDisable}
          onClickDownload={() =>
            ExportToExcel(
              exportData,
              valoresExibidos,
              fieldObject,
              'sisaf_ses_sESVinculo.xlsx',
              userID,
              'DAF', // Nome da interface
              entity, // Nome da entidade
            )
          }
        />
      </BarraInferiorBotoes>
    </>
  );
};

export default SESVinculo;
